import event from '../../../utils/analytics/event';
/**
 *
 * Custom hook which allows for link sharing via the clipboard.
 *
 * By default, it logs 1 piwik event: `event(['share', 'copy', <link>]);`, but you can pass in a custom `piwikEvent` to log instead.
 *
 * This event is logged when the user copies a link. If choosing to continue with the default piwik events provided, a value must be provided for the `link` prop.
 *
 * If a value is passed for the `piwikEvent` prop, then the button onClick will log that custom event instead.
 *
 * Example usage:
 *
 * ```js
 * import { useCopyShare } from '@minerva-analytics/pantheon';
 *
 * // Without custom piwik event
 * const Example = () => {
 *   const copyShare = useCopyShare("minervaanalytics.co");
 *   return (
 *     <button onClick={() => copyShare()}>
 *       Copy link
 *     </button>
 *   );
 * };
 *
 * // With custom piwik event
 * const Example = () => {
 *   const copyShare = useCopyShare("minervaanalytics.co", ['click', 'copy-share']);
 *   return (
 *     <Button onClick={() => copyShare()}>
 *       Copy link
 *     </Button>
 *   );
 * };
 * ```
 *
 * @param {string} link - link to be shared to the clipboard
 * @param {array} piwikEvent - optional custom event that is logged upon sharing. Must be an array in the form of `[category, action, name, value]`, though `name` and `value` are optional.
 *
 * @returns {function} - hook to be used for copying to clipboard
 *
 **/

var useCopyShare = function useCopyShare(link, piwikEvent) {
  if (link === void 0) {
    link = null;
  }

  if (piwikEvent === void 0) {
    piwikEvent = null;
  }

  var copyShare = function copyShare() {
    var loc = link || window.location.href;
    event(piwikEvent || ['share', 'copy', loc]);
    navigator.clipboard.writeText(loc);
  };

  return copyShare;
};

export default useCopyShare;